// src/components/Header.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import '../styles/Header.css';
import Logo from './Logo';

// SVGアイコンをコンポーネントとして定義
const HomeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-home">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
    <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
  </svg>
);

const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-logout">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
    <path d="M9 12h12l-3 -3" />
    <path d="M18 15l3 -3" />
  </svg>
);

const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-user">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
    <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
  </svg>
);

const HelpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-help-circle">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    <path d="M12 17l.01 0" />
    <path d="M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4" />
  </svg>
);

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await supabase?.auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('ログアウトに失敗しました', error);
    }
  };

  const handleTitleClick = () => {
    navigate('/');
  };

  const handleMyPageClick = () => {
    navigate('/my-page');
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  // 現在のページがアクティブかどうかを確認
  const isActive = (path) => {
    return location.pathname === path;
  };

  // 幅広レイアウトを適用するルート
  const wideLayoutRoutes = [
    '/rural-choice',
    '/first-choice',
    '/second-choice',
    '/exchange',
    '/rural-exchange'
  ];

  const isWideLayout = wideLayoutRoutes.some(path => location.pathname.startsWith(path));

  return (
    <header className="header">
      <div className={`header-container ${isWideLayout ? 'header-container-wide' : ''}`}>
        <div className="header-content">
          <h1 className="header-title" onClick={handleTitleClick}>
            <span className="header-title-full">
              <Logo height="24" color="white" />
            </span>
            <span className="header-title-short">
              <Logo height="24" color="white" />
            </span>
          </h1>

          <div className="header-actions">
            <button
              className={`icon-button ${isActive('/help') ? 'active' : ''}`}
              onClick={() => handleNavigate('/help')}
              aria-label="ヘルプ・使い方"
              title="ヘルプ・使い方"
            >
              <HelpIcon />
            </button>

            <button
              className={`icon-button ${isActive('/dashboard') ? 'active' : ''}`}
              onClick={() => handleNavigate('/dashboard')}
              aria-label="ダッシュボードへ移動"
            >
              <HomeIcon />
            </button>

            <button
              className={`icon-button ${isActive('/mypage') ? 'active' : ''}`}
              onClick={handleMyPageClick}
              aria-label="マイページへ移動"
            >
              <UserIcon />
            </button>

            <button
              className="icon-button logout-button"
              onClick={handleLogout}
              aria-label="ログアウト"
            >
              <LogoutIcon />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
